/** Read an error message without throwing on hostile getters or proxies.
 * Empty string messages are preserved. Unknown values use the caller's fallback.
 * Keep this module dependency-free: client, Workflow, and Convex callers share it.
 * Expected Convex failures use getConvexErrorMessage before this generic fallback.
 */
export function getErrorMessage(
  error: unknown,
  fallback = 'Unknown error'
): string {
  if (error instanceof Error) {
    return error.message
  }
  if (typeof error === 'string') {
    return error
  }
  if (typeof error === 'object' && error !== null) {
    try {
      const message: unknown = (error as { message?: unknown }).message
      if (typeof message === 'string') {
        return message
      }
    } catch {
      // A hostile getter/proxy must never turn error reporting into a throw.
    }
  }
  return fallback
}
